import loadable from '@loadable/component'

export const Hero = loadable(() => import('./Hero'))
export * from './__mocks__/Hero.mock'
export type { HeroProps, HeroImageProps } from './Hero'
